import { Text, type TextProps } from '@mantine/core';
import type { Practitioner } from '@medplum/fhirtypes';
import { formatPractitionerNameParts } from '@unify/fhir-model/resources/practitioner';

export type PractitionerNameTextProps = {
  practitioner?: Practitioner;
  /** Preferred (or sole) label when not passing a Practitioner. */
  primary?: string;
  /** Distinct legal name; omitted when absent or equal to preferred. */
  legal?: string;
} & Omit<TextProps, 'children'>;

/** Staff two-tone name: preferred in the inherited color, legal in gray.6 parentheses. */
export function PractitionerNameText({
  practitioner,
  primary,
  legal,
  ...textProps
}: PractitionerNameTextProps): JSX.Element {
  const parts = practitioner
    ? formatPractitionerNameParts(practitioner)
    : { primary: primary ?? '', legal };
  const shown = parts.primary || '—';
  return (
    <Text component="span" {...textProps}>
      {shown}
      {parts.legal ? (
        <Text component="span" inherit c="gray.6" ml={8}>
          ({parts.legal})
        </Text>
      ) : null}
    </Text>
  );
}
